// ADR-133 D9: one stored result item exactly as the sync produced it.
import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert, Typography, Stack,
} from '@mui/material';
import { ingestionSyncRunsApi } from '../../../services/api/ingestionSyncRunsApi';
import { formatSectionLabel } from '../../../utils/ingestionSyncRuns';
import JsonViewer from '../../common/JsonViewer';
import LoadingSpinner from '../../common/LoadingSpinner';

const ItemRecordDialog = ({ item, onClose }) => {
  const [record, setRecord] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!item?.id) return undefined;
    let cancelled = false;
    setIsLoading(true);
    setError(null);
    setRecord(null);
    ingestionSyncRunsApi.getItem(item.id)
      .then((data) => { if (!cancelled) setRecord(data); })
      .catch((err) => { if (!cancelled) setError(err.message || 'Failed to load the record'); })
      .finally(() => { if (!cancelled) setIsLoading(false); });
    return () => { cancelled = true; };
  }, [item?.id]);

  return (
    <Dialog open={Boolean(item)} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Stored record
        {item && (
          <Typography variant="body2" sx={{ color: '#64748B' }}>
            {`${formatSectionLabel(item.sectionKey)}${item.label ? ` · ${item.label}` : ''}`}
          </Typography>
        )}
      </DialogTitle>
      <DialogContent dividers>
        {isLoading && <LoadingSpinner />}
        {error && <Alert severity="error">{error}</Alert>}
        {record && (
          <Stack spacing={2}>
            {record.run?.startedAt && (
              <Typography variant="body2" sx={{ color: '#475569' }}>
                {`Recorded by the sync started ${new Date(record.run.startedAt).toLocaleString()}. `}
                Shown exactly as the sync returned it, not today&apos;s data.
              </Typography>
            )}
            <JsonViewer value={record.payload} defaultExpandDepth={2} />
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ItemRecordDialog;
